$( document ).ready(() => {
    setTimeout(() => {
        $(".container-video:has(.tac_activate)").addClass('hidden');

        $(".container-video button.tarteaucitronAllow").click(function () {
            $('.container-video').removeClass('hidden');
        });



    }, 500);
});
